export default __webpack_public_path__ + "static/media/pictogramBeaconSuperannuation64.729bc6e5.svg";